<dl class="iackathon-step-problematic__description-list">

    <div class="iackathon-step-problematic__description-container">
        <dt class="iackathon-step-problematic__description-term">
            {{ 'iackathon.chosen_sdg_theme' | translate }}
        </dt>
        <dd class="iackathon-step-problematic__description-value"
            [class.iackathon-step-problematic__description-value--sdg-theme]="hasThemeData()"
            [class.iackathon-step-problematic__description-value--no-data]="!hasThemeData()"
            [style.background-color]="hasThemeData() ? themeColor() : null">
            @if (hasThemeData()) {
                <mat-icon class="iackathon-step-problematic__sdg-theme-icon"
                          [svgIcon]="themeIcon()">
                </mat-icon>
                <span class="iackathon-step-problematic__sdg-theme-name">
                    {{ themeName() }}
                </span>
            } @else {
                {{ 'iackathon.data_not_provided' | translate }}
            }
        </dd>
    </div>

    <div class="iackathon-step-problematic__description-container">
        <dt class="iackathon-step-problematic__description-term">
            {{ 'iackathon.chosen_problematic' | translate }}
        </dt>
        <dd class="iackathon-step-problematic__description-value"
            [class.iackathon-step-problematic__description-value--no-data]="!problematic()">
            {{ problematic() || ('iackathon.data_not_provided' | translate) }}
        </dd>
    </div>

</dl>
